export default __webpack_public_path__ + "static/media/menu_red.0f03cc60.svg";